import React, { useEffect, useState } from "react";
import ReslutList from "./ReslutList";
import { AiFillCaretDown } from "react-icons/ai";
import { NavLink } from "react-router-dom";
import axios from "axios";

const ResultYesterday = () => {
  const [sportId, setSportId] = useState("Cricket");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);


  const getYesterdayDate = () => {
    const date = new Date();
    date.setDate(date.getDate() - 1);
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };

  const fetchResults = async () => {
    try {
      setLoading(true);
      const date = getYesterdayDate();
      const res = await axios.get("https://api.asianexchange.club/api/v1/results", {
        params: {
          startDate: date,
          endDate: date,
          sportId: sportId,
        },
      });
      setResults(res.data.data);
    } catch (error) {
      console.error("Failed to fetch results:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchResults();
  }, [sportId]);

  return (
    <>
      <div className="mobile-tabs1 mobile-tabs2">
        <div className="inner-btn-box !mt-1.5">
          <NavLink to="/result/today">
            <button className="btn-two inplay-btn">Today</button>
          </NavLink>
          <NavLink to="/result/yesterday">
            <button className="btn-three inplay-btn bg-blue-600 text-white">
              Yesterday
            </button>
          </NavLink>
          <NavLink to="/result/fiveDays" className="border-l border-white">
            <button className="btn-three inplay-btn">5 Days Ago</button>
          </NavLink>
        </div>
      </div>

      <div className="w-full p-1.5 bg-[#172832]">
        <div className="relative font-semibold font-sans">
          <select
            className="w-full appearance-none bg-white text-black font-semibold px-3 py-2 rounded-md focus:outline-none"
            value={sportId}
            onChange={(e) => setSportId(e.target.value)}
          >
            <option value="Cricket">CRICKET</option>
            <option value="Soccer">SOCCER</option>
            <option value="Tennis">TENNIS</option>
          </select>

          <div className="pointer-events-none absolute inset-y-0 right-3 flex items-center">
            <AiFillCaretDown className="text-black text-lg" />
          </div>
        </div>
      </div>

      {/* 🔽 Show result list */}
      <ReslutList results={results} loading={loading} />
    </>
  );
};

export default ResultYesterday;
